import React from 'react';
import { Outlet } from 'react-router-dom';

const EditAcademicVacancy: React.FC = () => <Outlet />;

export default EditAcademicVacancy;
